<form [formGroup]="form" autocomplete="off">
  <section>
    <div class="row">
      <!-- endpoint -->
      <div class="sm:tw-w-1/4">
        <get-apis-select-search
          [label]="fields + 'endpoint'"
          [control]="form?.get('endpoint')"
          [(value)]="model.endpoint"
          (valueChange)="onChangeEndpoint()"
          (onError)="onClose()"
        >
        </get-apis-select-search>
      </div>

      <!-- period -->
      <div class="sm:tw-w-1/4">
        <form-field
          [(value)]="model.period"
          (focusout)="onChangePeriod()"
          [control]="form?.get('period')"
          [label]="fields + 'period'"
          type="tel"
        >
        </form-field>
      </div>

      <div class="md:tw-w-1/6">
        <custom-select-search
          [label]="fields + 'periodType'"
          [items]="periodTypes"
          [control]="form?.get('periodType')"
          optionTitle="key"
          optionValue="value"
          [removable]="false"
          [(value)]="model.periodType"
          (valueChange)="onChangePeriodType()"
        >
        </custom-select-search>
      </div>

      <!-- limit -->
      <div class="sm:tw-w-1/4">
        <form-field
          [(value)]="model.limit"
          [control]="form?.get('limit')"
          (focusout)="onChangeLimit()"
          [label]="fields + 'limit'"
        >
        </form-field>
      </div>

      <div class="md:tw-w-1/12 tw-flex-center">
        <button
          class="mat-ripple btn tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise btn-danger"
          (click)="onRemoveIpRules(index)"
        >
          -
        </button>
      </div>
    </div>
  </section>
</form>
